module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', [_c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('h2', {
    staticClass: "chapter"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/title.jpg"
    }
  }), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Though I’ve never used the term “etiquette expert” to define myself, I have often voiced (threatened, really) the desire to send a handwritten note to every badly behaved person I’ve encountered with a short lesson on just how far good manners can take you. Thanks to the team at Adams for making this happen, especially Michelle Roy Kelly, for understanding my deep desire to rid the world of loutish behavior and recommending me for the project accordingly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks also to Wendy Simard for elevating my text with her editorial expertise. And to the ever-supportive Brendan O’Neill, who has been an amazing source of encouragement and positive energy from first pitch to final edit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, I’d like to thank the many, many people—friends, family members, foes, complete strangers—who have served as examples of behaviors both bad and good throughout this book (whether they know it or not).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32cf4da4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ack.vue
// module id = 75
// module chunks = 0